import React from 'react'

import Guid from '../../../utils/guid.js'

import {Button, Modal, ModalHeader, ModalActions} from '../UI/index.js'
import {formSpacing, FormRow, FormStack, Input} from '../UI/forms/index.js'

class SensorModal extends React.Component {
    constructor(props) {
        super(props)
        this.initialState = {
            modalIsOpen: false,
            newSensor: true,
            sensor: {id: '', name: '', sensorId: '', minTemperature: 0, maxTemperature: 0},
            validation: {}
        }

        this.state = JSON.parse(JSON.stringify(this.initialState))
    }

    open(sensor, index) {
        sensor = sensor ? JSON.parse(JSON.stringify(sensor)) : {id: Guid.generate(), name: '', sensorId: '', minTemperature: 0, maxTemperature: 0}

        this.setState({
            modalIsOpen: true,
            newSensor: typeof index === 'number',
            index,
            sensor
        })
    }

    close() {
        this.setState(this.initialState)
    }

    onChangeValue(key, event) {
        const sensor = {...this.state.sensor}
        sensor[key] = event.target.value
        this.setState({sensor})
    }

    onChangeChecked(key, event) {
        const sensor = {...this.state.sensor}
        sensor[key] = event.target.checked
        this.setState({sensor})
    }

    onValidate() {
        const sensor = {...this.state.sensor}
        const validation = {}
        let id = ''
        let valid = true

        if (!sensor.sensorId) {
            id = 'sensorId'
            validation.sensorId = true
            valid = false
        }

        if (!sensor.name) {
            id = 'name'
            validation.name = true
            valid = false
        }

        if (!valid) {
            const element = document.getElementById(id)
            if (element) {
                element.focus()
            }
        }

        this.setState({validation})
        return valid
    }

    onRemove(event) {
        event.preventDefault()

        this.props.onRemove(this.state.index)
        this.close()
    }

    onSubmit(event) {
        event.preventDefault()

        if (this.onValidate()) {
            // The number inputs give strings, the reseller model expects numbers
            const sensor = {
                ...this.state.sensor,
                minTemperature: parseFloat(this.state.sensor.minTemperature) || 0,
                maxTemperature: parseFloat(this.state.sensor.maxTemperature) || 0
            }

            this.props.onSubmit(sensor, this.state.index)
            this.close()
        }
    }

    render() {
        const {modalIsOpen, sensor, validation} = this.state

        return (
            <Modal show={modalIsOpen} onClose={this.close.bind(this)}>
                <ModalHeader title={sensor.id ? 'Bewerk sensor' : 'Nieuwe sensor'} onClose={this.close.bind(this)} style={{marginBottom: 0}} />

                <br />
                <form onSubmit={this.onSubmit.bind(this)}>

                    <FormStack style={{marginBottom: formSpacing.rowGap}}>
                        <Input
                            id='name'
                            label='Naam'
                            value={sensor.name}
                            isInvalid={validation.name}
                            onChange={this.onChangeValue.bind(this, 'name')}
                        />

                        <Input
                            id='sensorId'
                            label='Sensor ID'
                            value={sensor.sensorId}
                            isInvalid={validation.sensorId}
                            onChange={this.onChangeValue.bind(this, 'sensorId')}
                        />

                        <FormRow>
                            <Input
                                id='minTemperature'
                                type='number'
                                label='Minimum temperatuur'
                                value={sensor.minTemperature}
                                isInvalid={validation.minTemperature}
                                onChange={this.onChangeValue.bind(this, 'minTemperature')}
                                append='°C'
                            />

                            <Input
                                id='maxTemperature'
                                type='number'
                                label='Maximum temperatuur'
                                value={sensor.maxTemperature}
                                isInvalid={validation.maxTemperature}
                                onChange={this.onChangeValue.bind(this, 'maxTemperature')}
                                append='°C'
                            />
                        </FormRow>
                    </FormStack>

                    <ModalActions>
                        <Button variant='error' onClick={this.onRemove.bind(this)}>
                            Verwijder
                        </Button>

                        <Button type='submit'>
                            Opslaan
                        </Button>
                    </ModalActions>
                </form>
            </Modal>
        )
    }
}

export default (SensorModal)
